import * as React from 'react';
import { User } from '@starryui10/images/icons/User';
import Text from '@starryui10/typography/Text';
import { Center } from '@starryui10/layouts/Center';
import { PawIcon } from '@starrez/starryui';

interface IPlaceholderProps extends avatar.PlaceholderProps {
    initials?: string;
    species?: avatar.Species;
}

export const Placeholder = ({ initials, species = 'Human', size }: IPlaceholderProps) => {
    return (
        <>
            {initials ? (
                <Center>
                    <Text inline variant="xSmall.regular" color="white">
                        {initials}
                    </Text>
                </Center>
            ) : species === 'Human' ? (
                <div style={{ transform: 'translatey(20%)' }}>
                    <Center>
                        <User height={`${size}px`} width={`${size}px`} />
                    </Center>
                </div>
            ) : (
                <Center>
                    <PawIcon Height={`${size}px`} Width={`${size}px`} />
                </Center>
            )}
        </>
    );
};
